import axios from 'axios'

export const getLeaderboardUserEventHistory = async (
    organizationId,
    programId,
    userId,
    leaderboardId,
    page = 0,
    pageSize = 10
) => {
    let paramStr = '';
    //  const response = await axios.get(
    //     `/organization/${organizationId}/program/${programId}/user/${userId}/leaderboard-event-history?page=${page + 1}&pageSize=${pageSize}&${paramStr}`
    // );
    const response = await axios.get(
        `/organization/${organizationId}/program/${programId}/user/${userId}/leaderboard/${leaderboardId}/event-leaders-awards?page=${page + 1}&pageSize=${pageSize}&${paramStr}`
    );

    if (!response.data || response.data.length === 0) {
        return { results: [], count: 0 };
    }

    const data = {
        results: response.data.data || [],
        count: response.data.total || 0,
    };

    return data;
}